/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TUsersSessionModel,
  IUsersSessionRequest,
  IMappers,
  IUsersSessionResponse,
  IUsersSessionResponseError,
  TUsersSessionResponse,
} from './types';

const defaultConfig: TUsersSessionModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/users/session/',
  hostType: 'api',
} as TUsersSessionModel;

function createUsersSessionModel(parameters: IUsersSessionRequest): TUsersSessionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IUsersSessionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IUsersSessionRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchUsersSession<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IUsersSessionOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TUsersSessionResponse> {
  const { response, statusCode } = await httpApi.fetch(createUsersSessionModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IUsersSessionResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IUsersSessionResponseError);
    }
  }

  return { response, statusCode } as TUsersSessionResponse;
}

export { defaultConfig, createUsersSessionModel, fetchUsersSession };
